// extracted by mini-css-extract-plugin
module.exports = {"Demo":"Demo__Demo--1toY3","DemoNotification":"Demo__DemoNotification--2jcDO"};